module.exports = "/assets/data/709bb77c5ac373c9b83ffb3f48190f4b-NN1.data.json";